import { Person } from "../../../interfaces/person";
import { gql } from "apollo-angular";


type PersonSearchResult = {
  search_active_employees: Person[];
}
type PersonSearchVariables = {
  name: string;
}

export const SEARCH_ACTIVE_EMPLOYEES = gql<PersonSearchResult, PersonSearchVariables>`
  query search_active_employees ($name: String){
    search_active_employees(name: $name, hasUser:{value:true, operator: EQ, column: ACTIVE}){
      id
      name
      entity {
        entity_types {
          type {
            name
            tagType {
              name
            }
          }
        }
      }
      user{
        id
        username
      }
    }
  }
`
